import { Component, OnInit } from '@angular/core';
import { LIFE_CORP_TEL_NO } from '../app.constant';
import { SystemConfig } from '../models/SystemConfig';
import { SystemDataService } from '../service/data/system-data.service';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.css']
})
export class MaintenanceComponent implements OnInit {

  phoneNo;

  constructor(
    private systemDataService: SystemDataService) { }

  async ngOnInit() {

    let response = await this.getMaintenanceStatus();

    var firstKey = Object.keys(response)[0];

    var systemConfig: SystemConfig;

    if (firstKey.toUpperCase() == "OK") {
      systemConfig = response[firstKey];

      this.phoneNo= systemConfig.value;
    }
  }

  public getMaintenanceStatus(): Promise<any> {
    return this.systemDataService
      .getSystemConfig(LIFE_CORP_TEL_NO)
      .toPromise();
  }

}
